// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3okYT","toggle":"styles_toggle__3_F-8","preview":"styles_preview__9Ftoo"};